import { makeAutoObservable, runInAction } from "mobx";
import {
    countTotalInTab,
    getByLabTestLogin,
    getLabTestWaitingResult,
} from "./LabTestWaitingResultService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import localStorageService from "app/services/localStorageService";
import { getDefaultOrg } from "app/common/CommonFunctions";

const STATUS = 1;
const initialSearchObject = {
    keyword: "",
    fromDate: null,
    toDate: null,
    patientType: 3, //mặc định 3 loại bn lkt
}
export default class LabTestWaitingResultStore {
    labTestWaitingResultList = [];
    selectedLabTestWaitingResult = null;
    selectedLabTestWaitingResultList = [];
    totalElements = 0;
    totalPages = 0;
    page = 1;
    rowsPerPage = 10;
    loadingInitial = false;
    shouldOpenEditorDialog = false;
    shouldOpenConfirmationDialog = false;
    shouldOpenConfirmationDeleteListDialog = false;
    listTab = [];
    dictionarySystemId = "";
    rowLabTestWatingResultData = null;
    editable = false;
    searchObject = {...initialSearchObject}

    constructor() {
        makeAutoObservable(this);
    }

    updateEditable = () => {
        const { org, province } = getDefaultOrg();
        this.editable = (
            localStorageService.isLab() ||
            localStorageService.isAdmin() ||
            (org?.id === this.rowLabTestWatingResultData?.orgEncounterId) ||
            (org?.id === this.rowLabTestWatingResultData?.orgTestId) ||
            (localStorageService.isProvince && (
                province?.id === this.rowLabTestWatingResultData?.provinceEncounterId ||
                province?.id === this.rowLabTestWatingResultData?.provinceTestId
            ))
        )
    }

    setEditable = (editable) => this.editable = editable;

    setRowLabTestWatingResultData = row => {
        this.rowLabTestWatingResultData = row;
        this.updateEditable()
    }

    setLoadingInitial = (state) => {
        this.loadingInitial = state;
    };

    handleSetSearchObject = obj => {
        this.page = 1;
        this.searchObject = {...obj}
    }

    countTotalInTab = () => {
        const searchObject = {
            ...this.searchObject,
            status: STATUS,
        };

        countTotalInTab(searchObject).then(({ data }) => {
            runInAction(() => {
                this.listTab = data?.length > 0 ? data : []
            })
        }).catch((error) => {
            console.log(error);
            toast.warning("toast.load_fail");
        }).finally(() => {
            this.setLoadingInitial(false);
        })
    }

    updatePageData = async () => {
        this.loadingInitial = true;
        const searchObject = {
            ...this.searchObject,
            pageIndex: this.page,
            pageSize: this.rowsPerPage,
            status: STATUS,
            dictionarySystemId: this.dictionarySystemId,
        };

        try {
            let data = await getByLabTestLogin(searchObject);
            runInAction(() => {
                this.labTestWaitingResultList = data.data.content;
                this.totalElements = data.data.totalElements;
                this.totalPages = data.data.totalPages;
            })
            this.setLoadingInitial(false);
        } catch (error) {
            console.log(error);
            toast.warning("toast.load_fail");
            this.setLoadingInitial(false);
        }
    };

    setDictionarySystemId = (id) => {
        this.dictionarySystemId = id;
    }

    setPage = (page) => {
        this.page = page;
        this.updatePageData();
    };

    setRowsPerPage = (event) => {
        this.rowsPerPage = event.target.value;
        this.page = 1;
        this.updatePageData();
    };

    handleChangePage = (event, newPage) => {
        this.setPage(newPage);
    };

    handleEditLabTestWaitingResult = (id) => {
        this.getLabTestWaitingResult(id).then(() => {
            this.shouldOpenEditorDialog = true;
        });
    };
    handleClose = () => {
        this.shouldOpenEditorDialog = false;
        this.shouldOpenConfirmationDialog = false;
        this.shouldOpenConfirmationDeleteListDialog = false;
        this.setRowLabTestWatingResultData(null);
        this.setEditable(false);
        this.countTotalInTab();
        this.updatePageData();
    };

    getLabTestWaitingResult = async (id) => {
        if (id != null) {
            try {
                let res = await getLabTestWaitingResult(id);
                this.handleSelectLabTestWaitingResult(res.data);
            } catch (error) {
                console.log(error);
                toast.warning("toast.get_fail");
            }
        } else {
            this.handleSelectLabTestWaitingResult(null);
        }
    };
    
    handleSelectLabTestWaitingResult = (LabTestWaitingResult) => {
        this.selectedLabTestWaitingResult = LabTestWaitingResult;
    };

    resetSearchObject = () => {
        this.handleSetSearchObject(initialSearchObject)
    }
}